import React from 'react';
import PropTypes from 'prop-types';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

var classnames = createCommonjsModule(function (module) {
/* global define */
(function () {

  var hasOwn = {}.hasOwnProperty;

  function classNames() {
    var classes = [];

    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (!arg) continue;
      var argType = typeof arg;

      if (argType === 'string' || argType === 'number') {
        classes.push(arg);
      } else if (Array.isArray(arg) && arg.length) {
        var inner = classNames.apply(null, arg);

        if (inner) {
          classes.push(inner);
        }
      } else if (argType === 'object') {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      }
    }

    return classes.join(' ');
  }

  if ( module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else {
    window.classNames = classNames;
  }
})();
});

var wrapWithRequired = function wrapWithRequired(validator, isRequired) {
  if (isRequired) {
    return {
      isRequired: validator
    };
  }

  return validator;
};

var validReactComponentsByDisplayName = function validReactComponentsByDisplayName(displayName, isRequired) {
  return wrapWithRequired(function (props, propName, componentName) {
    var children = props == null ? void 0 : props[propName];

    if (!children) {
      if (isRequired) {
        return new Error("\"" + propName + "\" is required for \"" + componentName + "\".");
      }

      return null;
    }

    try {
      // Render props children
      if (! /*#__PURE__*/React.isValidElement(children) && !React.Children.count(children)) {
        var component = children();

        if ( /*#__PURE__*/React.isValidElement(component)) {
          var _component$type;

          if ((component == null ? void 0 : (_component$type = component.type) == null ? void 0 : _component$type.displayName) !== displayName) {
            var _component$type2;

            return new Error("Invalid \"" + propName + "\" supplied to \"" + componentName + "\". \"" + propName + "\" is expected to be a \"" + displayName + "\" component but received \"" + (component == null ? void 0 : (_component$type2 = component.type) == null ? void 0 : _component$type2.displayName) + "\".");
          }

          return null;
        }

        if (React.Children.count(component)) {
          for (var index = 0; index < React.Children.count(component); index++) {
            var _element$type;

            var element = component[index];

            if ((element == null ? void 0 : (_element$type = element.type) == null ? void 0 : _element$type.displayName) !== displayName) {
              var _element$type2;

              return new Error("Invalid \"" + propName + "\" supplied to \"" + componentName + "\". \"" + propName + "\" is expected to be a \"" + displayName + "\" component but received \"" + (element == null ? void 0 : (_element$type2 = element.type) == null ? void 0 : _element$type2.displayName) + "\".");
            }
          }

          return null;
        }
      }

      if ( /*#__PURE__*/React.isValidElement(children)) {
        var _children$type;

        if ((children == null ? void 0 : (_children$type = children.type) == null ? void 0 : _children$type.displayName) !== displayName) {
          var _children$type2;

          return new Error("Invalid \"" + propName + "\" supplied to \"" + componentName + "\". \"" + propName + "\" is expected to be a \"" + displayName + "\" component but received \"" + (children == null ? void 0 : (_children$type2 = children.type) == null ? void 0 : _children$type2.displayName) + "\".");
        }

        return null;
      }

      if (React.Children.count(children)) {
        for (var _index = 0; _index < React.Children.count(children); _index++) {
          var _element$type3;

          var _element = children[_index];

          if ((_element == null ? void 0 : (_element$type3 = _element.type) == null ? void 0 : _element$type3.displayName) !== displayName) {
            var _element$type4;

            return new Error("Invalid \"" + propName + "\" supplied to \"" + componentName + "\". \"" + propName + "\" is expected to be a \"" + displayName + "\" component but received \"" + (_element == null ? void 0 : (_element$type4 = _element.type) == null ? void 0 : _element$type4.displayName) + "\".");
          }
        }

        return null;
      }
    } catch (err) {
      return new Error(err.message);
    }

    return new Error("Invalid \"" + propName + "\" supplied to \"" + componentName + "\". \"" + propName + "\" is expected to be a \"" + displayName + "\" component.");
  }, isRequired);
};

var modules_39fbd8cc = {"grid":"Grid_module_grid__da3b8c09","grid__item":"Grid_module_grid__item__da3b8c09","grid--1":"Grid_module_grid_1__da3b8c09","grid--2":"Grid_module_grid_2__da3b8c09","grid--3":"Grid_module_grid_3__da3b8c09","grid--4":"Grid_module_grid_4__da3b8c09"};

var Row = function Row(_ref) {
  var _cx;

  var className = _ref.className,
      cols = _ref.cols,
      customCols = _ref.customCols,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(modules_39fbd8cc.grid, (_cx = {}, _cx[modules_39fbd8cc["grid--" + cols]] = cols && !customCols && modules_39fbd8cc["grid--" + cols], _cx), className)
  }, children);
};

Row.displayName = "Row";

var Cell = function Cell(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(modules_39fbd8cc.grid__item, className)
  }, children);
};

Cell.displayName = "Cell";
Row.propTypes = {
  className: PropTypes.string,
  cols: PropTypes.oneOf([1, 2, 3, 4]),
  customCols: PropTypes.bool,

  /**
   * All children must be using the `Cell` component.
   *
   * `Cell[] | Cell`
   *
   * @type {Cell[]|Cell}
   */
  children: validReactComponentsByDisplayName(Cell.displayName, true).isRequired
};
Row.defaultProps = {
  className: undefined,
  cols: undefined,
  customCols: undefined
};
Cell.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
Cell.defaultProps = {
  className: undefined
};

export { Cell, Row };
//# sourceMappingURL=index.js.map
